import { GetCoverageTypePayload, GetCoverageTypeReturn } from "@/api/types";
import { baseApi } from "./base";

const coverageTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCoverageType: builder.query<GetCoverageTypeReturn, GetCoverageTypePayload>({
      query: (payload) => {
        return {
          url: "/coverage_type/get",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetCoverageTypeQuery } = coverageTypeApi;
